export const APP_NAME = 'HRMS'
export const APP_VERSION = 'v1.0.0'
export const PERSIST_STORE_NAME = 'hrms'
export const REDIRECT_URL_KEY = 'redirectUrl'
